/* eslint-disable indent */
(function () {
    'use strict';

    angular.module('MktzapApp.Controllers')
    .controller('FormalizationSettingsController', formalizationSettingsController);

    formalizationSettingsController.$inject = ['$rootScope', 'CompanyService', 'NotificationService'];

    function formalizationSettingsController ($rootScope, CompanyService, NotificationService) {
        $rootScope.getPageLabels('menu.config.formalizationSettings');

        var vmFormalizationCtrl = this;

        loadMetadata()

        function loadMetadata () {
          CompanyService
            .loadMetadata()
            .$promise
            .then(function (data) {
                vmFormalizationCtrl.metadata = data;
            })
            .catch(function (error) {
                NotificationService.errorHandler(error, $rootScope.labels.errorLoadMeta);
            })
        }

        vmFormalizationCtrl.allow = function () {
            CompanyService
                .saveMetadata(vmFormalizationCtrl.metadata)
                .$promise
                .then(function (data) {
                    vmFormalizationCtrl.metadata = data;
                    $rootScope.company_metadata = data;
                    NotificationService.successHandler(data, $rootScope.labels.saveConfig);
                    loadMetadata()
                })
                .catch(function (error) {
                    NotificationService.errorHandler(error, $rootScope.labels.errorConfig);
                });
        };
    }
})();
